import React from "react";
import { Link, useParams, Navigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const SLUG_TO_KEY = {
  impressum: "imprint",
  imprint: "imprint",
  datenschutz: "privacy",
  privacy: "privacy",
  agb: "terms",
  terms: "terms",
  versand: "shipping",
  shipping: "shipping",
};

const Legal = () => {
  const { slug } = useParams();
  const { t } = useLanguage();
  const key = SLUG_TO_KEY[slug];

  if (!key) return <Navigate to="/" replace />;

  const page = t.legal[key];

  return (
    <div className="min-h-screen bg-black text-white pt-32 pb-24" data-testid={`legal-page-${slug}`}>
      <div className="mx-auto max-w-3xl px-6 md:px-12">
        <Link
          to="/"
          data-testid="legal-back-home"
          className="inline-flex items-center gap-2 font-condensed uppercase tracking-widest text-xs text-white/60 hover:text-[#00A651] transition-colors mb-10"
        >
          <ArrowLeft className="w-3 h-3" />
          {t.legal.back}
        </Link>

        <h1 className="font-brush text-5xl md:text-7xl text-white leading-none mb-2">
          {page.title}
        </h1>
        <p className="font-condensed uppercase tracking-widest text-xs text-white/40 mb-14">
          {t.legal.last_updated} {new Date().toLocaleDateString("de-CH")}
        </p>

        <div className="space-y-12">
          {page.sections.map((s, i) => (
            <section key={i} data-testid={`legal-section-${i}`}>
              <h2 className="font-display text-2xl md:text-3xl uppercase tracking-wide text-[#00A651] mb-4 border-l-2 border-[#00A651] pl-4">
                {s.heading}
              </h2>
              <p className="text-white/75 leading-relaxed whitespace-pre-line text-base">
                {s.body}
              </p>
            </section>
          ))}
        </div>

        <div className="mt-20 pt-8 border-t border-white/10 text-sm text-white/50">
          4keeperz · Segsan Gröschel · Eschenbach, Schweiz · info@4keeperz.ch
        </div>
      </div>
    </div>
  );
};

export default Legal;
